export default __webpack_public_path__ + "static/yoga-aef6bc8d9a6b185b37f523e36e14ccd7.jpg";